import { STORE_BASE_URL } from "../../CONSTANTS";
import { callPostAxios, callPutAxios } from "../common/common";

export const getStoreAllRecord = (data) => {
    return callPostAxios(STORE_BASE_URL() + 'getAllRecords', data, 'storeRecord');
};

export const addStore = (data) => {
    return callPostAxios(STORE_BASE_URL() , data, 'Add Record');
};

export const editStore = (uuid, data) => {
    return callPutAxios(STORE_BASE_URL() + uuid , data, 'Edit Record', 'Edit Record');
};

export const storeOptionsByWarehouseId = (uuid) => {
    return callPostAxios(STORE_BASE_URL() + "getStoreByWareHouseUuid/" + uuid , {}, 'StoreOptions');
};
